/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputFrequencyStatus
 */
export interface OutputFrequencyStatus {
    /**
     * 
     * @type {number}
     * @memberof OutputFrequencyStatus
     */
    cause: number;
    /**
     * 
     * @type {string}
     * @memberof OutputFrequencyStatus
     */
    reason: string;
}

/**
 * Check if a given object implements the OutputFrequencyStatus interface.
 */
export function instanceOfOutputFrequencyStatus(value: object): boolean {
    if (!('cause' in value)) return false;
    if (!('reason' in value)) return false;
    return true;
}

export function OutputFrequencyStatusFromJSON(json: any): OutputFrequencyStatus {
    return OutputFrequencyStatusFromJSONTyped(json, false);
}

export function OutputFrequencyStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputFrequencyStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'cause': json['cause'],
        'reason': json['reason'],
    };
}

export function OutputFrequencyStatusToJSON(value?: OutputFrequencyStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cause': value['cause'],
        'reason': value['reason'],
    };
}

